const parseFormValue = (value: string): boolean | number | string => {
  if (value === "true" || value === "false") return Boolean(value);
  if (value.match(/^-?\d*(\.\d+)?$/) && !isNaN(parseFloat(value)))
    return parseFloat(value);

  return value;
};

const isNested = (field: string): boolean => field.split(".").length === 2;
const getParentKey = (field: string): string => field.split(".")[0] as string;
const getChildKey = (field: string): string => field.split(".")[1] as string;

export const transformFormData = <T>(form: FormData): T => {
  const object: Partial<T> = {};

  for (const entry of form.entries()) {
    const [key, value] = entry;

    if (isNested(key)) {
      if (!object.hasOwnProperty(getParentKey(key))) {
        Object.defineProperty(object, getParentKey(key), {
          value: {},
          writable: true,
          enumerable: true,
        });
      }

      const parentRef = object[getParentKey(key) as keyof T];

      Object.defineProperty(parentRef, getChildKey(key), {
        value: parseFormValue(value as string),
        writable: true,
        enumerable: true,
      });
    } else {
      Object.defineProperty(object, key, {
        value: parseFormValue(value as string),
        writable: true,
        enumerable: true,
      });
    }
  }

  return object as T;
};
